



















import { defineComponent } from '@vue/composition-api';
import LearnMore from '~/components/atoms/LearnMore/LearnMore.vue';
import { useRouteExtended } from '~/composables';
import { ROUTES } from '~/constants/routes';

export default defineComponent({
  name: 'ReturnsAndWarranty',
  components: {
    LearnMore,
  },
  setup() {
    const { getAdjustedSlug } = useRouteExtended();
    const returnsLearnMoreUrl = getAdjustedSlug(ROUTES.RETURN_POLICY);
    const guaranteeLearnMoreUrl = getAdjustedSlug(ROUTES.PREMIUM_GUARANTEE);

    return { returnsLearnMoreUrl, guaranteeLearnMoreUrl };
  },
});
